module.exports = __webpack_public_path__ + "static/media/josetteAlvarado.c9466147.jpg";